import { render } from "./CommentCreate.vue?vue&type=template&id=7a2fe59d"
import script from "./CommentCreate.vue?vue&type=script&lang=js"
export * from "./CommentCreate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/Documents/Works/fast_energy_task_manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__